import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const StaffDetail = asyncComponent(() =>
  import('../../../containers/authorised/organisation/staff/StaffDetail')
)
const StaffExamTemplates = asyncComponent(() =>
  import('../../../containers/authorised/organisation/staff/examTemplate/StaffExamTemplates.js')
)
const StaffImpressions = asyncComponent(() =>
  import('../../../containers/authorised/organisation/staff/impression/Impression.js')
)
const StaffProcedureDuration = asyncComponent(() =>
  import('../../../containers/authorised/organisation/staff/procedureDuration/ProcedureDuration')
)
const NonAdminStoreContact = asyncComponent(() =>
  import('../../../containers/authorised/organisation/staff/storeContact/NonAdminStoreContact')
)
const StoreEyeglassLensType = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensType')
)
const StoreEyeglassAddons = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassAddons')
)
const StoreStockLenses = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreStockLenses')
)
const StoreEyeglassFrame = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassFrame')
)
const StorePhysicalInventory = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StorePhysicalInventory')
)
const StoreReconcile = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreReconcile')
)
const StoreEyeglassLensMaterial = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreEyeglassLensMaterial')
)
const StoreMiscItems = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/eyeglassLens/StoreMiscItems')
)
const StoreContactLens = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/contactLens/StoreContactLens')
)
const StoreCleaningSolution = asyncComponent(() =>
  import('../../../containers/authorised/storeSettings/orderSettings/contactLens/StoreCleaningSolution')
)

const NonAdminRoutes = (
  <Switch>
    <Route exact path="/organisation/staffs/:id/staff-detail" component={StaffDetail} />
    <Route exact path="/organisation/staffs/:id/exam-templates" component={StaffExamTemplates} />
    <Route exact path="/organisation/staffs/:id/impressions" component={StaffImpressions} />
    <Route exact path="/organisation/staffs/:id/procedure-duration" component={StaffProcedureDuration} />
    <Route exact path="/organisation/staffs/:id/store-contacts" component={NonAdminStoreContact} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory" component={StoreEyeglassLensType} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/lens-material" component={StoreEyeglassLensMaterial} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/frame" component={StoreEyeglassFrame} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/physical-inventory" component={StorePhysicalInventory} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/reconcile" component={StoreReconcile} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/add-ons" component={StoreEyeglassAddons} />
    <Route exact path="/organisation/staffs/:id/eyeglass-inventory/stock-lenses" component={StoreStockLenses} />
    <Route exact path="/organisation/staffs/:id/misc-inventory" component={StoreMiscItems} />
    <Route exact path="/organisation/staffs/:id/contact-lens-inventory" component={StoreContactLens} />
    <Route exact path="/organisation/staffs/:id/contact-lens-inventory/cleaning-solution" component={StoreCleaningSolution} />
  </Switch>
);

export default NonAdminRoutes;
